const cleanStorage = (
  $rootScope,
  appEvents,
  appSectionsStorage,
  appSession,
  requestsCache,
) => {
  'ngInject';

  const removeEvent = appSession.onSessionEnd(() => {
    appSectionsStorage.cleanAll();
    requestsCache.delete();
  });

  $rootScope.$on('$destroy', () => {
    removeEvent();
  });
};

export default cleanStorage;
